// extracted by mini-css-extract-plugin
export default {"facts__highlight":"AV74ZL4","facts__subline":"cuLwWiI"};